import { Component, OnInit,OnDestroy } from '@angular/core';
import { SharedService } from '../shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FirstLetterUpperCase } from '../pipe/firstletteruppercase.pipe';

@Component({
  selector: 'app-address-not-available',
  templateUrl: './address-not-available.component.html',
  styleUrls: ['./address-not-available.component.css']
})
export class AddressNotAvailableComponent implements OnInit,OnDestroy {
  service_address: Object;
  constructor(private activatedRoute: ActivatedRoute , private sharedService: SharedService,
    private localStorageService: LocalStorageService, private router: Router) {
      
      
     this.sharedService.setHeaderTitle('default_page');
      if (this.localStorageService.get('token') != null) {
        this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
        .then(res => {
            if (res.status === 'success') {
              this.router.navigate(['./dashboard']);
            }
        });
      }else {
        const that = this.sharedService;
        setTimeout(function(){
          that.setHeaderTitle('service-not-available');
        }, 10);
      this.service_address = this.localStorageService.get('address_for_billing');
      }
      this.localStorageService.set('returnUrl', '/enroll');
  }

  ngOnInit() {
  }

  ngOnDestroy(){ 
    location.replace("/enroll");
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/address-not-available/address-not-available.component.ts